const WHATSAPP_LINK = 'https://wa.me/905321737544?text=Merhaba,%20Google%20reklam%C4%B1ndan%20ula%C5%9F%C4%B1yorum.%20Ak%C3%BC%20/%20yol%20yard%C4%B1m%20veya%20yedek%20par%C3%A7a%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum.';

export default function FloatingWhatsApp() {
  return (
    <a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noopener noreferrer"
      className="hidden md:flex fixed bottom-6 right-6 z-50 w-14 h-14 md:w-16 md:h-16 items-center justify-center bg-green-600 hover:bg-green-500 rounded-full shadow-2xl transition-all duration-300 hover:scale-110"
      aria-label="WhatsApp'tan yaz"
    >
      <i className="fab fa-whatsapp text-white text-2xl md:text-3xl"></i>
    </a>
  );
}